import { render } from "./property-staticmap.vue?vue&type=template&id=57332d8d"
import script from "./property-staticmap.js?vue&type=script&lang=js"
export * from "./property-staticmap.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__